let language = 'en'
let market = 'US'

export default {
    initialize: (lang, mark) => {
        language = lang
        market = mark
    },
    replaceLocale: (string) => {
        if (string == null) {
            return ''
        }

        return string.replace(/\{locale\}/g, language + '_' + market)
    }
}
